import React from 'react';
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';

import { OrderSchemaType } from '../order.schema';
import { FormGroup, Label, Textarea } from '../style';

/** Observações para produção do pedido: só o aço tem; entra no núcleo pelo slot do Details. */
export const ProductionObservationField: React.FC = () => {
  const { register, formState: { errors } } = useFormContext<OrderSchemaType>();

  return (
    <FormGroup>
      <Label htmlFor="productionObservation">Observações para produção</Label>
      <Textarea
        id="productionObservation"
        {...register('productionObservation')}
        hasError={!!get(errors, 'productionObservation')}
      />
    </FormGroup>
  );
};
